/**
 * KAELEN VEYL — Paladin / Yuksek Elf / Asker / Seviye 1
 * Hazir karakter. Davet linkinden arkadaslariniz bunu gorerek baslar.
 *
 * Bu veri motorun dogru calistigini gosteren canli ornek (fixture) olarak da
 * kullanilir: aggregate.test.ts bu karakteri dogrulayan beklentileri icerir.
 */

import type { CharacterInput } from '@tttrpg/rules'

export const KAELEN_VEYL: CharacterInput = {
  id: 'kaelen-veyl',
  ruleset: '5.1',
  level: 1,
  xp: 300,

  classes: [{ classId: 'paladin', level: 1, isPrimary: true }],
  raceId: 'high-elf',
  backgroundId: 'soldier',

  // Standart Dizgi: 15, 14, 13, 12, 10, 8
  //   STR 13 | DEX 14 | CON 12 | INT 8 | WIS 10 | CHA 15
  //
  // Neden GUC 13? Zincir Zirhi GUC 13 gerektirir. 5e kurali: gereksinim
  // karsilanmazsa YAKIN DOVUS SALDIRILARINDA DEZANTAJ gelir. 13 tam esik
  // deger: hem zirhi giyebilirsin hem de DEX 16 ile AC 19'a cikabilirsin.
  // (Motor bu kurallari bilmeden yazilmis bir sheet'te bu hatayi yakalayamaz.)
  abilityScores: { str: 13, dex: 14, con: 12, int: 8, wis: 10, cha: 15 },

  // Elf varyanti: +1 Karizma (oyuncu secimi)
  asiBonuses: { cha: 1 },

  // Irk: Perception | Arka Plan: Athletics, Intimidation
  // Sinif (2 secim): Insight, Persuasion
  proficiencies: [
    'skill.perception',
    'skill.athletics',
    'skill.intimidation',
    'skill.insight',
    'skill.persuasion',
    'armor.light',
    'armor.medium',
    'armor.heavy',
    'armor.shields',
    'weapon.simple',
    'weapon.martial',
    'tool.gamingSet',
    'tool.landVehicles',
    'language.common',
    'language.elvish',
    'language.draconic',
    'language.celestial',
  ],

  inventory: [
    { itemId: 'chain-mail', quantity: 1, attuned: false, equipSlot: 'body', weight: 0 },
    { itemId: 'shield', quantity: 1, attuned: false, equipSlot: 'offhand', weight: 0 },
    { itemId: 'longsword', quantity: 1, attuned: false, equipSlot: 'mainhand', weight: 0 },
    { itemId: 'spear', quantity: 6, attuned: false, equipSlot: null, weight: 0 },
    { itemId: 'explorers-pack', quantity: 1, attuned: false, equipSlot: 'back', weight: 0 },
    { itemId: 'gaming-set', quantity: 1, attuned: false, equipSlot: null, weight: 0 },
  ],

  conditions: [],
  tempHitPoints: 0,
}

/** Hazir buyu listeleri (sheet'te gosterilmek uzere). */
export const KAELEN_SPELLS = {
  cantrips: [
    { id: 'guidance', name: 'Rehberlik (Guidance)', source: 'Paladin', ready: true },
    { id: 'sacred-flame', name: 'Kutsal Alev (Sacred Flame)', source: 'Paladin', ready: true },
    { id: 'druidcraft', name: 'Druidcraft', source: 'Yüksek Elf', ready: true },
  ],
  prepared: [
    { id: 'bless', name: 'Kutsama (Bless)', level: 1, concentration: true, slot: '1' },
    {
      id: 'cure-wounds',
      name: 'Sağaltma (Cure Wounds)',
      level: 1,
      concentration: false,
      slot: '1',
    },
  ],
  /** Uzun Dinlenme ile yenilenen havuzlar. */
  pools: [
    { id: 'lay-on-hands', name: 'Yağma', current: 5, max: 5, recharge: 'Uzun Dinlenme' },
    { id: 'divine-sense', name: 'Tanrısal Algı', current: 4, max: 4, recharge: 'Uzun Dinlenme' },
  ],
}

export const KAELEN_IDENTITY = {
  name: 'Kaelen Veyl',
  nickname: 'Veyl',
  alignment: 'Yaslı İyi',
  className: 'Paladin',
  raceName: 'Yüksek Elf',
  backgroundName: 'Asker',
  rank: 'Teğmen (Lieutenant)',
  deity: null,
  oath: 'Sadakat Yemini (Oath of Devotion)',
  playerNote: 'Çağrıldığı yerde konuşmaz. Kılıcı kınına girmiş taşır.',
}
